import { render, staticRenderFns } from "./chooseOne.vue?vue&type=template&id=85f59aaa&scoped=true"
import script from "./chooseOne.vue?vue&type=script&lang=js"
export * from "./chooseOne.vue?vue&type=script&lang=js"
import style0 from "./chooseOne.vue?vue&type=style&index=0&id=85f59aaa&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f59aaa",
  null
  
)

export default component.exports